/** Tokens visuais — lotes do evento (mesmo padrão dos cupons) */
export const LOTE_ACCENT = "#F96030";
export const LOTE_INK = "#1a2035";
export const LOTE_ACCENT_SOFT = "rgba(249, 96, 48, 0.08)";

export const loteToolbarSx = {
  mb: 2,
  p: 2,
  borderRadius: 2,
  bgcolor: "grey.50",
  border: "1px solid",
  borderColor: "grey.200",
  borderLeft: `4px solid ${LOTE_ACCENT}`,
};

export const loteSectionSx = {
  p: { xs: 1.5, sm: 2 },
  borderRadius: 2,
  border: "1px solid",
  borderColor: "grey.200",
  bgcolor: "background.paper",
};

export const loteCardSx = {
  p: 2,
  borderRadius: 2,
  border: "1px solid",
  borderColor: "grey.200",
  bgcolor: "background.paper",
  transition: "border-color 0.15s, box-shadow 0.15s",
  "&:hover": {
    borderColor: "rgba(249, 96, 48, 0.35)",
    boxShadow: "0 4px 16px rgba(26, 32, 53, 0.06)",
  },
};
